import { FC } from "react";
import {
  Container,
  Loader,
  ProgressItem,
  ProgressPrev,
} from "./StepProgress.styled";
import { useTranslation } from "../../../hooks/useTranslation";

type Props = {
  count: number;
  value: number;
};

export const StepProgress: FC<Props> = ({ count, value }) => {
  const { t } = useTranslation();

  const items = [...Array(count)];
  return (
    <Container>
      <Loader>{t("stepProgress")}</Loader>
      <ProgressPrev>
        {items.map((_, index) => (
          <ProgressItem
            className={index === value ? "active" : ""}
            key={index}
          />
        ))}
      </ProgressPrev>
    </Container>
  );
};
